
import {getViewGroup} from '../api/getViewGroup';
import {setGroupsViewAction} from '../action';

const setViewGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewGroup(params);
    
            if (data.status === 'success') {
                dispatch(setGroupsViewAction(data.groups));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setViewGroups
}